import React, { useMemo } from 'react';
import { useComponentTheme } from '../../theme/theme.context.esm.js';

// import { usePropId } from '../../utils/use-prop-id'

function Skeleton(props) {
  var theme = useComponentTheme('Skeleton');
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$width = props.width,
    width = _props$width === void 0 ? 'full' : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 'lg' : _props$height,
    _props$animation = props.animation,
    animation = _props$animation === void 0 ? 'pulse' : _props$animation,
    _props$radius = props.radius,
    radius = _props$radius === void 0 ? 'none' : _props$radius;
  // const id = usePropId(props.id)
  var classes = useMemo(function () {
    return theme({
      className: className,
      width: width,
      height: height,
      animation: animation,
      radius: radius
    });
  }, [theme, className, width, height, animation, radius]);
  return /*#__PURE__*/React.createElement("div", {
    className: "csg-tw-skeleton ".concat(classes)
    // id={id}
    ,
    "aria-busy": "true",
    "aria-hidden": "true"
  });
}

export { Skeleton as default };
//# sourceMappingURL=skeleton.esm.js.map
